import { useEffect } from 'react';
import { BroadbandWebTitle } from '../constants';

export const useDocumentTitle = (pageTitle?: string) => {
  useEffect(() => {
    if (pageTitle) document.title = pageTitle;
    return () => {
      // Change title to default Broadband web page title
      document.title = BroadbandWebTitle;
    };
  }, [pageTitle]);
};
